// Rosin-Tropfen an der Unterkante der Produktkarte: einmal pro Karte beim ersten Hover mit der Maus.
// Gleiche Form und gleiche Klassen wie snippets/hdsc-drip.liquid (Styles in hdsc-base.css), nur hier erzeugt, damit die Karten kein Markup mitschleppen.
const DRIP = '<svg viewBox="0 0 44 74" aria-hidden="true"><path class="drip__body" d="M14 1C18 1 19 7 19 15C19 25 15 31 15 42C15 55 29 55 29 42C29 31 25 25 25 15C25 7 26 1 30 1Z"/><path class="drip__line" d="M0 1H14C18 1 19 7 19 15C19 25 15 31 15 42C15 55 29 55 29 42C29 31 25 25 25 15C25 7 26 1 30 1H44"/><ellipse class="drip__shine" cx="19.5" cy="43" rx="1.6" ry="3.4"/></svg>'

const canHover = matchMedia('(hover: hover)').matches
const still = matchMedia('(prefers-reduced-motion: reduce)').matches

if (canHover && !still && !window.__hdscCardDrip) {
  window.__hdscCardDrip = true
  const seen = new WeakSet()
  document.addEventListener('pointerover', (e) => {
    if (e.pointerType !== 'mouse') return
    const frame = e.target instanceof Element ? e.target.closest('.card__frame') : null
    if (!frame || seen.has(frame)) return
    seen.add(frame)
    const drip = document.createElement('span')
    drip.className = 'drip'
    drip.innerHTML = DRIP
    frame.append(drip)
    requestAnimationFrame(() => requestAnimationFrame(() => drip.classList.add('is-in')))
    // Nach dem Auslaufen kurz stehen lassen, dann ausblenden und entfernen
    setTimeout(() => {
      drip.classList.add('is-gone')
      setTimeout(() => drip.remove(), 700)
    }, 4200)
  })
}
